import { useIsMobile } from '@energiebespaarders/hooks';
import { Box } from '@energiebespaarders/symbols';
import { useMediaQuery } from '@energiebespaarders/symbols/hooks';
import { breakpointsPx } from '@energiebespaarders/symbols/styles/breakpoints';
import { Image } from 'react-datocms';
import styled, { css } from 'styled-components';
import type { dummy_dummy_content_ImageBlockRecord } from '~/types/generated/cms/dummy';

export const StyledDatoImage = styled(Image)<{ $autoWidth?: boolean }>`
  ${x =>
    x.$autoWidth &&
    css`
      & img {
        width: auto !important;
      }
    `}
`;

interface DatoImageWrapperProps {
  $rounded?: boolean;
  $width: string;
  $height: string;
}

export const DatoImageWrapper = styled(Box)<DatoImageWrapperProps>`
  position: relative;
  flex: 1;

  & ${StyledDatoImage} {
    min-width: ${x => x.$width};
    max-height: ${x => x.$height};
    max-width: 100%;
    border: 0;
    border-radius: ${x => (x.$rounded ? '6px' : 'unset')};

    & img {
      border-radius: ${x => (x.$rounded ? '6px' : 'unset')};
      object-fit: contain;
    }
  }
`;

interface Props {
  block: dummy_dummy_content_ImageBlockRecord;
  height?: string;
}

const ImageBlock: React.FC<Props> = ({ block, height }) => {
  const isMobile = useIsMobile();
  const isTablet = useMediaQuery(breakpointsPx.lg);
  if (!block.image) return null;
  return (
    <DatoImageWrapper
      $rounded
      $height={height ?? isMobile ? '180px' : isTablet ? '240px' : '360px'}
    >
      <StyledDatoImage data={block.image!.responsiveImage!} style={{ borderRadius: 6 }} />
    </DatoImageWrapper>
  );
};

export default ImageBlock;
